import { IsicCardPartialStoreState, ISIC_CARD_STATE_KEY } from "./isic-card.reducer";

export const getIsicCardActivationFinished = (state: IsicCardPartialStoreState) =>
    state[ISIC_CARD_STATE_KEY].isicCardFinished;

export const getError = (state: IsicCardPartialStoreState) => state[ISIC_CARD_STATE_KEY].error;

export const getIsicCardActivationLoading = (state: IsicCardPartialStoreState) =>
    state[ISIC_CARD_STATE_KEY].isicCardLoading;